import React from 'react';
import style from './style.module.scss';
import {IHandlers, IProps} from './types';
import {renderIf} from "app/services/reactUtils.service";
import {BookingType} from "app/app.types";
import {Button, Typography} from "@material-ui/core";
import IconsService from "app/services/icons/icons.service";
import {IconTypes} from "app/services/icons/icons.types";
import classNames from 'classnames';
import AppThemeService from 'app/services/theme/appTheme.service';

const NS = 'TimeSlotMessaging';

export default function TimeSlotMessaging({
  warningMsgs, errorMsgs, noTables, timeIsOpen, notWalkinBookingMethod, bookingType, isStandbyListEnabled, hasPaid,
  handleStandbyBtn, handleWaitListBtn, showRemoveWaitList
}: IProps & IHandlers) {

  const isWalkinBookingMethod = !notWalkinBookingMethod; // @todo: clean up props and change to positive. severity: medium

  const {palette} = AppThemeService.getAppTheme();
  const StandbyIcon = IconsService.getIcon(IconTypes.standbyList);
  const isStandby = bookingType === BookingType.StandbyList;
  const isWaitList = bookingType === BookingType.WaitList;
  const showStandbyBtn = isStandbyListEnabled && !isWalkinBookingMethod;

  const showNoTableMessage = timeIsOpen && (noTables || isWalkinBookingMethod);
  const showWarningMessage = warningMsgs && warningMsgs.length > 0;
  const showErrorMessage = errorMsgs && errorMsgs.length > 0;

  if (!showWarningMessage && !showErrorMessage && !showNoTableMessage) {
    return null;
  }

  return (
    <div className={style.root} data-testid="container">

      {/* warnings */}
      {showWarningMessage && (
        <div style={{color: palette.warning.main}} data-testid="warning-container">
          {warningMsgs.map((warning, i) => (
            <Typography key={`warning-${i}`} className={style.msg} data-testid="warning-option">{warning}</Typography>
          ))}
        </div>
      )}

      {/* errors */}
      {showErrorMessage && (
        <div style={{color: palette.error.main}} data-testid="error-container">
          {errorMsgs.map((error, i) => (
            <Typography key={`error-${i}`} className={style.msg} data-testid="error-option">{error}</Typography>
          ))}
        </div>
      )}

      {/* timeIsOpen: Show nothing here if on selected time the venue is closed */}
      {renderIf(showNoTableMessage, () => (
        <div className={style.msgWrap} data-testid="table-container">

          {renderIf(noTables, () => {
            return renderIf(!isWalkinBookingMethod && bookingType === BookingType.Booking, () => (
              <Typography style={{color: palette.error.main}} className={style.msg} data-testid="no-table-selected-msg">
                No table selected
              </Typography>
            ), () => {
              return renderIf(isWalkinBookingMethod, () => (
                <Typography style={{color: palette.error.main}} className={style.msg} data-testid="msg-for-wait-list">
                  No table selected. Booking will be added to the Wait List
                </Typography>
              ), () => {
                return renderIf(isStandbyListEnabled, () => (
                  <Typography style={{color: palette.warning.main}} className={style.msg} data-testid="msg-for-standby-list">
                    No table selected. Standby List available.
                  </Typography>
                ))
              })
            })
          })}

          {/* Standby List button */}
          {renderIf(noTables && showStandbyBtn, () => (
            <div data-testid="standby-container">
              <Button
                data-testid="standby-list-button"
                className={classNames({
                  [style.standbyBtn]: true,
                  [style.standbyBtnIsRemoveState]: isStandby
                })}
                variant="contained" color="primary" size="small"
                onClick={handleStandbyBtn}
              >
                <StandbyIcon className={style.standbyIcon}/>
                {isStandby ? 'Remove from ' : 'Add to '}standby list
              </Button>
              {renderIf(hasPaid, () => (
                <Typography color="error" className={style.errorMsg} data-testid="payment-msg">
                  Please note: a payment transaction is attached to this booking.
                </Typography>
              ))}
            </div>
          ))}

          {/* Wait List button */}
          {renderIf(isWalkinBookingMethod && handleWaitListBtn, () => (
            <div data-testid="wait-list-container">
              <Button
                data-testid="wait-list-button"
                className={classNames({
                  [style.waitListBtn]: true,
                  [style.waitListBtnIsRemoveState]: showRemoveWaitList
                })}
                variant="contained" color="primary" size={showRemoveWaitList ? 'small' : 'medium'}
                onClick={handleWaitListBtn}
              >
                {renderIf(showRemoveWaitList && isWaitList, () => (
                  <>Remove from wait list</>
                ), (
                  <>Add to wait list</>
                ))}
              </Button>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
